import { Col, SelectField } from '@/components';
import type { AnalysisSearchFormType } from '@/features/search/_models/analysis-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import {
  AggregationTargetTypeLabelModifier,
  aggregationTargetTypeEnum,
} from '@/utils/enum';
import { type FC, memo, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

export const AggregationTargetColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<AnalysisSearchFormType>();

  const analysisTarget = useWatch({ control, name: 'analysisTarget' });

  const options = useMemo(() => {
    const target: z.infer<typeof aggregationTargetTypeEnum>[] =
      analysisTarget === 'expenditure'
        ? aggregationTargetTypeEnum.options
        : [aggregationTargetTypeEnum.enum.total];
    return target.map((value) => ({
      value,
      label: AggregationTargetTypeLabelModifier[value],
    }));
  }, [analysisTarget]);

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="aggregationTargetType"
        label={t('aggregation-target')}
        control={control}
        options={options}
        allowClear={false}
        errors={errors}
      />
    </Col>
  );
});
